import { Box, Flex, Text } from '@mantine/core'

import {
  formatChangePercent,
  getPercentChangeColor,
} from '@/app/[locale]/price/[slug]/_components/CoinLineChart/utils'
import { useCoinContext } from '@/app/[locale]/price/[slug]/_contexts/CoinContext'
import AnimatedPrice from '@/components/AnimatedPrice'
import { useSsrContext } from '@/contexts/ssr'

interface StockChartInfoTitleProps {
  coinPrice?: number
  coinPercentChange?: number
  isMouseInChart: boolean
}

export default function StockChartInfoTitle({
  coinPrice,
  coinPercentChange,
  isMouseInChart,
}: StockChartInfoTitleProps) {
  const { coin } = useCoinContext()
  const { selectedCurrency } = useSsrContext()
  const changeColor = getPercentChangeColor(coinPercentChange ?? 0)
  const changeText = coinPercentChange ? formatChangePercent(coinPercentChange * 100) : void 0

  return (
    <>
      <Flex visibleFrom="md" align="baseline" gap={8} h={40}>
        <AnimatedPrice
          key={`desktop-${isMouseInChart}`}
          variant={'balances'}
          price={coinPrice}
          tokenSymbol={coin.symbol}
          disabledPriceAnimate={isMouseInChart}
          disabledConvert={isMouseInChart}
          isDecimalGrey
        />
        <Text variant={'body'} c={'#7B849B'}>
          {selectedCurrency}
        </Text>
        <Text c={changeColor} variant={'body'}>
          {changeText}
        </Text>
      </Flex>
      <Box hiddenFrom="md">
        <Flex h={40} align="baseline" gap={4}>
          <AnimatedPrice
            key={`mobile-${isMouseInChart}`}
            variant={'balances'}
            price={coinPrice}
            tokenSymbol={coin.symbol}
            disabledPriceAnimate={isMouseInChart}
            disabledConvert={isMouseInChart}
            isDecimalGrey
          />
          <Text variant={'body'} c={'#7B849B'}>
            {selectedCurrency}
          </Text>
        </Flex>
        <Box h={20}>
          <Text c={changeColor} variant={'body'}>
            {changeText}
          </Text>
        </Box>
      </Box>
    </>
  )
}
